import { showToast } from '@tix-ticketing/ui-components';
import { useIntl } from 'react-intl';

/**
 * The label and warning toast for a product quantity stepper held back by the
 * units left of the product.
 */
export const useProductMaxReached = () => {
  const intl = useIntl();

  const maxReachedTitle = intl.formatMessage({
    id: 'products.dialog.maxReached.title',
    defaultMessage: 'Maximum reached',
  });

  const showMaxReachedToast = (max: number | null | undefined) => {
    if (max == null) return;
    showToast({
      title: maxReachedTitle,
      message: intl.formatMessage(
        {
          id: 'products.dialog.maxReached.message',
          defaultMessage:
            'Only {max, plural, one {# is} other {# are}} left of this product.',
        },
        { max }
      ),
      severity: 'warning',
    });
  };

  return { maxReachedTitle, showMaxReachedToast };
};
